(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('change', (event) => {
  if (event.target.matches('[data-localization-select]')) event.target.form.submit()
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('.attia-cart [data-step]');if(!button)return;const input=button.parentElement.querySelector('input');const step=Number(button.dataset.step);input.value=Math.max(0,(parseInt(input.value,10)||0)+step);input.dispatchEvent(new Event('change',{bubbles:true}));});
document.addEventListener('change',function(event){if(!event.target.matches('.attia-cart input[name="updates[]"]'))return;const input=event.target;if(!input.checkValidity()){input.reportValidity();return;}const form=input.closest('form');form.requestSubmit(form.querySelector('[name="update"]'));});
document.addEventListener('submit',function(event){const form=event.target;if(!form.matches('.attia-cart__form'))return;const cart=form.closest('.attia-cart');cart.setAttribute('aria-busy','true');const status=cart.querySelector('.attia-cart__status');status.textContent=status.dataset.message;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-collection-sort]')) return
    const url = new URL(window.location.href)
    url.searchParams.set('sort_by', event.target.value)
    window.location.assign(url.toString())
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-root]').forEach((root) => {
      const mainImage = root.querySelector('[data-product-main-image]');
      root.querySelectorAll('[data-image-src]').forEach((thumb) => thumb.addEventListener('click', () => {
        if (mainImage) { mainImage.removeAttribute('srcset'); mainImage.src = thumb.dataset.imageSrc; mainImage.alt = thumb.dataset.imageAlt; }
        root.querySelectorAll('[data-image-src]').forEach((item) => item.classList.toggle('is-active', item === thumb));
      }));

      const variantsNode = root.querySelector('[data-product-variants]');
      if (!variantsNode) return;
      const variants = JSON.parse(variantsNode.textContent);
      const radios = [...root.querySelectorAll('[data-option-group] input')];
      radios.forEach((radio) => radio.addEventListener('change', () => {
        const selected = [...root.querySelectorAll('[data-option-group]')].map((group) => {
          const checked = group.querySelector('input:checked');
          const label = group.querySelector('[data-selected-option]');
          if (label && checked) label.textContent = checked.value;
          return checked ? checked.value : '';
        });
        const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
        if (!variant) return;
        root.querySelector('[data-variant-id]').value = variant.id;
        root.querySelector('[data-product-price]').textContent = variant.price;
        const compare = root.querySelector('[data-compare-price]');
        compare.textContent = variant.compare;
        compare.hidden = !variant.onSale;
        const addButton = root.querySelector('[data-add-to-cart]');
        addButton.disabled = !variant.available;
        root.querySelector('[data-add-label]').textContent = variant.available ? 'Add to cart' : 'Sold out';
        if (variant.image && mainImage) { mainImage.removeAttribute('srcset'); mainImage.src = variant.image; }
        history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
      }));
    });
  });

  } catch(e) { console.error(e); }
})();
})();
